export const LOADING_PRODUCT = "LOADING_PRODUCT";
export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";
export const GET_PRODUCT_ID = "GET_PRODUCT_ID";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";

export const LOADING_PRODUCT_DOCUMENT = "LOADING_PRODUCT_DOCUMENT";
export const REMOVE_PRODUCT_DOCUMENT = "REMOVE_PRODUCT_DOCUMENT";
export const ADD_PRODUCT_DOCUMENT = "ADD_PRODUCT_DOCUMENT";
export const ADD_PRODUCT_MULTI_DOCUMENT = "ADD_PRODUCT_MULTI_DOCUMENT";
export const DOWNLOAD_PRODUCT_DOCUMENT = "DOWNLOAD_PRODUCT_DOCUMENT";
export const GET_PRODUCT_DOCUMENT_LIST = "GET_PRODUCT_DOCUMENT_LIST";